import { twitchPlayerUrl } from "../../lib/pip.js";

/**
 * Twitch's embedded player for one channel, filling the picture-in-picture frame's slot (the frame
 * scales it past Twitch's 400×300 minimum). `parent` is the page's own hostname, so a custom
 * domain works as the store's subdomain does. Swapping the channel reloads the frame's `src` in
 * place; the dock never reparents it, which would restart the stream. A new `key` remounts it,
 * which the dock does after a Twitch link, since the player reads its sign-in only on load.
 *
 * `data-categories="essential"` comes before `src`: Termly's autoblocker holds third-party iframes
 * until consent, and the shopper asked for this one by opening picture-in-picture.
 */
export function TwitchPipPlayer({ channel, title }: { channel: string; title: string }) {
  return (
    <iframe
      data-categories="essential"
      title={title}
      src={twitchPlayerUrl(channel, window.location.hostname)}
      allow="autoplay; fullscreen; picture-in-picture"
      allowFullScreen
      className="block size-full border-0"
    />
  );
}
